/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DevCodeIcon64Regular = forwardRef('DevCodeIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M40.637 8.431a1.5 1.5 0 0 0-2.873-.862l-14.4 48a1.5 1.5 0 1 0 2.873.862l14.4-48Z" }),
        React.createElement("path", { d: "M16.56 16.94a1.5 1.5 0 0 1 0 2.12L5.956 29.668a3.3 3.3 0 0 0 0 4.666L16.56 44.94a1.5 1.5 0 1 1-2.122 2.121L3.834 36.456a6.3 6.3 0 0 1 0-8.91L14.439 16.94a1.5 1.5 0 0 1 2.122 0Z" }),
        React.createElement("path", { d: "M47.44 16.94a1.5 1.5 0 0 1 2.12 0l10.606 10.605a6.3 6.3 0 0 1 0 8.91L49.561 47.06a1.5 1.5 0 1 1-2.122-2.12l10.606-10.607a3.3 3.3 0 0 0 0-4.666L47.44 19.06a1.5 1.5 0 0 1 0-2.122Z" })));
});
